module.exports = __webpack_public_path__ + "img/51626511_L.b60c7759.png";